<template>
  <a
    id="container-download-app"
    class="container-banner container-download-app no-gutters tAc"
    href="https://wegow.app.link/PlwT8EHdi0"
    rel="noreferrer"
    target="_blank"
    :class="{ home: home }"
  >
    <div class="posR container-mobile-img" />
    <div class="app-container-right">
      <div class="container-text">
        <p class="title" v-html="$t('wegow.banner.downloadApp.title')" />
      </div>
      <div class="apps">
        <div class="apps-icon appStore" />
        <div class="apps-icon googlePlay" />
      </div>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    home: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss">
.container-download-app {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  background-image: linear-gradient($black-25-color, $black-25-color),
    url("@/assets/images/BANNER-APP_2048x200.webp");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  .container-mobile-img {
    width: 400px;
    height: 170px;
    margin-top: 15px;
    background-image: url("@/assets/images/mvl_desktop.webp");
    background-repeat: no-repeat;
    background-size: contain;

    @media screen and (max-width: $screen-md) {
      background-image: url("@/assets/images/mvl_mobile.webp");
    }

    @media screen and (max-width: $screen-xs) {
      display: none;
    }
  }

  .apps {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 15px;

    .apps-icon {
      margin: 0 10px;
    }
  }
}
</style>
